<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { AppMessageBox } from '@libs/ui';

import type { PeekPriceModalMultiIngredientItinerary } from '../models';
import {
  isMultiIngredientAccommodationCard,
  isMultiIngredientBookableTransportCard,
  isMultiIngredientUnbookableTransportCard,
} from '../models';

import PeekPriceUnbookableTransportCard from './PeekPriceUnbookableTransportCard.vue';
import PeekPriceSmallHotelCard from './PeekPriceSmallHotelCard.vue';
import PeekPriceSmallBookableTransportCard from './PeekPriceSmallBookableTransportCard.vue';

interface PeekPriceMultiIngredientProps {
  itinerary: PeekPriceModalMultiIngredientItinerary;
}

const props = defineProps<PeekPriceMultiIngredientProps>();

const browserStore = useBrowserStore();
</script>

<template>
  <div class="peek-price-multi-itinerary">
    <AppMessageBox
      v-if="browserStore.isSmallerThan900px"
      message-type="brand-lagoon"
    >
      <template #text>
        {{ $t('planner.calendar_shows_date_price') }}
        <span class="inspected-accommodation-name">
          {{ props.itinerary.inspectedAccommodationName }}
        </span>
      </template>
    </AppMessageBox>

    <template v-for="(card, index) of props.itinerary.cards" :key="index">
      <PeekPriceUnbookableTransportCard
        v-if="isMultiIngredientUnbookableTransportCard(card)"
        :data="card.data"
      />
      <PeekPriceSmallBookableTransportCard
        v-if="isMultiIngredientBookableTransportCard(card)"
        :data="card.data"
      />
      <PeekPriceSmallHotelCard
        v-if="isMultiIngredientAccommodationCard(card)"
        :data="card.data"
      />
      <div
        v-if="index !== props.itinerary.cards.length - 1"
        class="separator"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.peek-price-multi-itinerary {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  .inspected-accommodation-name {
    @include font-label-m-bold;
  }

  .separator {
    border-bottom: 1px solid var(--color-neutral-20);
  }
}
</style>
